import type { IPlaybackScheduleRoot } from '@lucimark/shared/models/player-registration-payload'
import { isScheduleRootAssignment } from '@lucimark/shared/helpers/playbackScheduleMaterializationIdentity'

/** Display title / version for the pending-swap overlay while on-air Feed stays unchanged. */
export function resolvePendingPlaylistSwapTitle(root: IPlaybackScheduleRoot): {
  title: string
  version?: number
} {
  if (isScheduleRootAssignment(root)) {
    const title = root.title.trim() !== '' ? root.title.trim() : 'Playlist'
    return { title, version: root.version }
  }
  const first = root.playlists?.[0]
  const title = first?.title?.trim() ? first.title.trim() : 'Playlist'
  return { title }
}
